export default "__VITE_ASSET__962f30d2__"